import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss']
})
export class NoticeModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NoticeModalComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {}



  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

}
